import { FormControl, Input, FormErrorMessage, InputProps } from '@chakra-ui/react';
import { FC, forwardRef } from 'react';
import { When } from 'react-if';

interface Props extends InputProps {
  error?: string;
  label: string;
}

const FormInput: FC<Props> = forwardRef<any, Props>(({ error, label, ...props }, ref) => {
  return (
    <FormControl isInvalid={!!error}>
      <Input
        ref={ref}
        size="lg"
        id={label}
        placeholder={label + (props.isRequired ? '*' : '')}
        {...props}
      />
      <When condition={!!error}>
        <FormErrorMessage>{error}</FormErrorMessage>
      </When>
    </FormControl>
  );
});

export default FormInput;
